import React, { useState, useEffect } from "react"

import './PushMessages.scss'

import { connect } from 'react-redux'

import Axios from "axios"

import MobileHeader from "../../components/commonComponents/mobileHeader/MobileHeader"

import { setAlert } from "../../redux/actions/alertActions"

import { hostDetect } from "../../config/envConfig"

import { Info } from "react-feather";

const PushMessages = ({siteId, siteUrl, setAlert}) => {

    const [apiLoading, setApiLoading] = useState(false)

    const [code, setCode] = useState("Code to copy...");

    useEffect(() => {

        setApiLoading(true)

        Axios.get(`${hostDetect('api')}/push-code/?site_id=${siteId}`, { withCredentials: true })
        .then(response => {
            let success = response.data.success;

            if(success){
                let code_script = response.data.data.code;

                setCode(code_script)
            } else {
                setCode('Ошибка. Обновите страницу и попробуйте еще раз...')
                
                let errMessage = response.data.data.message;
                setAlert('error', errMessage);
            }
        })
        .catch(err => {
            setCode('Ошибка. Обновите страницу и попробуйте еще раз...')
            setAlert('error', 'Не получилось отправить запрос!');
        })
        .finally(() => {
            setApiLoading(false)
        })

    }, [siteId])

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setAlert('success', 'Текст успешно скопирован в буфер обмена!')
        } catch (error) {
            console.error("Ошибка при копировании текста:", error);
            setAlert('error', 'Не удалось скопировать текст.')
        }
    };

    function removeTrailingSlash(str) {
        if (str.endsWith('/')) {
            return str.slice(0, -1);
        }
        return str;
    }

    return (
        <div className="push-messages">

            <MobileHeader />

            {
                apiLoading ? 
                    <div className="loader__small">
                        Загрузка данных...
                    </div> : null
            }
            
            <div className="card">
                <div className="card-header">
                    Скачать service worker
                </div>
                <div className="card-body">
                    <a href={`${hostDetect('api')}/push-code/service-worker?site_id=${siteId}`} className="btn mb-1 btn-primary">Скачать</a>
                    <div className="warning-field">
                        <div className="d-flex align-items-center">
                            <Info size={14} style={{marginRight: 4}} /> Разместите файл Service Worker (spr_sw.js) в корневой директории проекта, чтобы он был доступен по прямому URL: <br />
                        </div>
                        <span>{ siteUrl ? removeTrailingSlash(siteUrl) : 'https://domain' }/spr_sw.js</span>
                    </div>
                </div>
            </div>
                
            <div className="card">
                <div className="card-header">
                    Получить код для встраивания на сайт
                </div>
                <div className="card-body">
                    <div className="form-group row">
                        <div className="col-sm-6">
                            <textarea 
                                className="form-control mb-3" 
                                value={ code }
                                rows="10"
                                cols="30" 
                                disabled></textarea>
                            <button className="btn mb-1 btn-primary" onClick={ handleCopyClick }>Копировать</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



function mapStateToProps(state){
    return{
        siteId: state.siteInfo.site.id,
        siteUrl: state.siteInfo.site.url
    }
}

const mapDispatchToProps = {
    setAlert
}

export default connect(mapStateToProps, mapDispatchToProps)(PushMessages)